// Time helper functions

// Generate array of time options in 15-minute increments
// Returns times in 24-hour format: ["00:00", "00:15", "00:30", ..., "23:45"]
export const generateTimeOptions = () => {
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const hourStr = hour.toString().padStart(2, '0');
      const minuteStr = minute.toString().padStart(2, '0');
      times.push(`${hourStr}:${minuteStr}`);
    }
  }
  return times;
};

// Format time for display (already in HH:MM format, so just return it)
export const formatTime = (time) => {
  if (!time) return '';
  return time;
};

// Compare two time strings for sorting
// Returns -1 if time1 < time2, 1 if time1 > time2, 0 if equal
export const compareTime = (time1, time2) => {
  if (!time1 && !time2) return 0;
  if (!time1) return 1; // No time goes after times with values
  if (!time2) return -1;

  const [hour1, min1] = time1.split(':').map(Number);
  const [hour2, min2] = time2.split(':').map(Number);

  const minutes1 = hour1 * 60 + min1;
  const minutes2 = hour2 * 60 + min2;

  return minutes1 - minutes2;
};
